import '../../../app.es6';
import angular from 'angular';

const COMPONENT_NAME = 'dialogAdvertise';
class DialogAdvertise {
  /* @ngInject */
  constructor (Resource) {
    this.Resource = Resource;
    DialogAdvertise.$inject = ['Resource'];
  }
}

angular.module('myApp').component(COMPONENT_NAME,
  {
    bindings: {
      name: '@' + COMPONENT_NAME
    },
    controller: DialogAdvertise,
    templateUrl: 'app/components/dialog/advertise/dialog-advertise.template.html'
  }
);



// WEBPACK FOOTER //
// ./app/components/dialog/advertise/dialog-advertise-controller.es6